module.exports = __webpack_public_path__ + "img/hotelFamily-5.a3a65b05.jpg";